import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryAllMsgNotify(params) {
  return request({
    url: URL.mdm.queryAllMsgNotify,
    method: 'get',
    params
  })
}
export function unreadQuantityFunc(params) {
  return request({
    url: URL.mdm.unreadQuantityUrl,
    method: 'get',
    params
  })
}
export function readMsgFunc(data) {
  return request({
    url: URL.mdm.readMsgUrl,
    method: 'post',
    data
  })
}
// 根据分类查询信息
export function getMessage(data) {
  return request({
    url: URL.mdm.getMsgNotify,
    method: 'post',
    data
  })
}
// 获取分类信息的数量
export function getUnReadNumber(codes, dateRange) {
  return request({
    url: URL.mdm.getUnReadNumber + '?codes=' + codes + '&dateRange=' + dateRange,
    method: 'get'
  })
}
// 设置为已读
export function readMsg(data) {
  return request({
    url: URL.mdm.readMsg,
    method: 'put',
    data
  })
}
// 查询个人订阅的配置
export function getClassifySubscription() {
  return request({
    url: URL.sys.getClassifySubscription,
    method: 'get'
  })
}
// 更改个人订阅的配置
export function saveClassifySubscription(data) {
  return request({
    url: URL.sys.saveClassifySubscription,
    method: 'post',
    data
  })
}
// 获取沃宝的订阅状态
export function getWoBaoState() {
  return request({
    url: URL.sys.getWoBaoState,
    method: 'get'
  })
}
// 取消沃宝的订阅状态
export function unSubscribeWoBao() {
  return request({
    url: URL.sys.unSubscribeWoBao,
    method: 'put'
  })
}
// 获取沃宝的提示信息
export function getWoBaoRemind(dateRange) {
  return request({
    url: URL.mdm.getWoBaoRemind + '?dateRange=' + dateRange,
    method: 'get'
  })
}

